<template>
  <div class="outer-box" >
    <h4>Get Location Wallet details for Agency</h4>

    <div class="inner-box" style="text-align: left; width: 600px;">
       <input class="hl_input--wrap border" :class="[isCompanyIdEmpty && 'border-danger']" type="text" placeholder="Agency ID" v-model="companyId" />
      <p v-if="isCompanyIdEmpty" class="mt-2 text-capitalize" :class="[isCompanyIdEmpty && 'text-danger']">Please Enter Agency ID</p>

      <button class="btn btn-success" :class="[isCompanyIdEmpty ? 'mt-0' : 'mt-5']" @click="downloadWalletTransactionDetails">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else>Download</span>
      </button>

    </div>
  </div>
</template>

<script>
import { SaasService } from "@/services";

export default {
  data() {
    return {
      companyId: '',
      processing: false,
      response:'',
      isCompanyIdEmpty:false,
    };
  },
  methods: {
    async downloadWalletTransactionDetails(){
      try {
        if(!this.companyId.trim().length){
          this.isCompanyIdEmpty = true
          setTimeout(()=>{
            this.isCompanyIdEmpty = false
          },5000)
          return
        }
        this.processing = true
        let { data } =  await SaasService.downloadCompanyWalletTransactions(this.companyId)
        const blob = new Blob([data], { type: 'text/csv' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `locations-details-${this.companyId}.csv`
        link.click()
        URL.revokeObjectURL(link.href)
        this.processing = false
      } catch (error) {
        this.response = error.message
        this.processing = false
      }
    }
  }
}
</script>

<style>
</style>
